import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { AngularNodeViewComponent, TiptapDraggableDirective } from 'ngx-tiptap';

@Component({
    selector: 'admin-tiptap-email-form-answers-container',
    templateUrl: `./tiptap-email-form-answers-container.component.html`,
    styleUrls: ['./tiptap-email-form-answers-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TiptapDraggableDirective, NgClass],
})
export class TiptapEmailFormAnswersContainerComponent extends AngularNodeViewComponent {
    get isEditable() {
        return this.editor().isEditable;
    }
}
